import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import { 
  LocationOn, 
  CalendarToday, 
  WorkOutline, 
  People,
  BarChart,
  PersonAdd
} from "@mui/icons-material";

const AllOppCard = ({ 
  id = "0-012345.1",
  role = "Role",
  location = "Irvine, CA 92612",
  startDate = "Jan 1, 2024",
  endDate = "Aug 1, 2024",
  rate = "$120/hr",
  tAndE = "No T&E",
  applicants = "7 applicants",
  description = "[Project Description]",
  showDetails = true,
  onApply,
  onShowDetails,
  style
}) => {
  return (
    <Card 
      sx={{
        width: "100%",
        maxWidth: 400,
        borderRadius: 3,
        border: '1px solid #e0e0e0',
        boxShadow: 'none',
        backgroundColor: '#fafafa',
        ...style
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header with ID and buttons */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            ID: {id}
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton
              size="small"
              sx={{ 
                border: '1px solid #e0e0e0',
                borderRadius: 1.5,
                width: 40,
                height: 32,
                backgroundColor: 'white'
              }}
            >
              <BarChart sx={{ fontSize: 18, color: "text.secondary" }} />
            </IconButton>
            <Button
              variant="contained"
              size="small"
              startIcon={<PersonAdd sx={{ fontSize: 16 }} />}
              sx={{ 
                backgroundColor: "#f5f5f5",
                color: "text.primary",
                boxShadow: 'none',
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                border: '1px solid #e0e0e0',
                px: 2,
                '&:hover': {
                  backgroundColor: "#e8e8e8",
                  boxShadow: 'none'
                }
              }}
              onClick={onApply}
            >
              Apply
            </Button>
          </Box>
        </Box>

        {/* Role Title */}
        <Typography 
          variant="h5" 
          sx={{ 
            mb: 3,
            fontSize: "24px",
            fontWeight: 600,
            color: "text.primary"
          }}
        >
          {role}
        </Typography>

        {/* Location with flag */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
          <Typography sx={{ fontSize: 16 }}>🇺🇸</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
            {location}
          </Typography>
        </Box>

        {/* Date Range */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
          <CalendarToday sx={{ fontSize: 16, color: "#4caf50" }} />
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
            {startDate} - {endDate}
          </Typography>
        </Box>

        {/* Rate and Applicants */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 4, mb: 2.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WorkOutline sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
              {rate}, {tAndE}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <People sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
              {applicants}
            </Typography>
          </Box>
        </Box>

        {/* Description */}
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ 
            mb: 2.5,
            fontSize: 14,
            lineHeight: 1.5
          }}
        >
          {description}
        </Typography>

        {/* Show Details */}
        {showDetails && (
          <Button
            variant="text"
            sx={{ 
              color: "#8B4513",
              textTransform: "none",
              fontWeight: 500,
              p: 0,
              minWidth: "auto",
              fontSize: 14,
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline'
              }
            }}
            onClick={onShowDetails}
          >
            Show details ▼
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default AllOppCard;
